import type { FC } from 'react';

import { ExistingChat } from '@/features/chats/components/ExistingChat';
import type {
  AppNativeStackScreenProps,
  AppRoute
} from '@/navigation/types/navigation';

export type Props = AppNativeStackScreenProps<typeof AppRoute.Chat>;

export const ChatScreen: FC<Props> = ({ route }) => {
  const chatId = route.params.id;

  return <ExistingChat chatId={chatId} />;
};
